module.exports = __webpack_public_path__ + "img/ng.39d6e6c9.svg";